import { changeShowInformation } from 'store/modules/showInformation/action'
import { useDispatch } from 'react-redux'
import { MdClose } from 'react-icons/md'
import { OkButton, Wrapper } from './styles'

const InformationMessage: React.FC = () => {
  const dispatch = useDispatch()
  const closeInformationModal = () => {
    dispatch(changeShowInformation(false))
  }

  return (
    <Wrapper>
      <div style={{ textAlign: 'end' }}>
        <button id="fechar" onClick={() => closeInformationModal()}>
          <MdClose id="close" size={30} />
        </button>
      </div>
      <h2>Sua Assinatura Social foi realizada com sucesso!</h2>
      <br />
      <h2>
        Você já pode iniciar seus estudos desfrutando de toda a qualidade do Direção Concursos!
        Contudo, ressaltamos que, para continuar com acesso aos cursos, precisamos que você nos
        envie em até 2 dias úteis* os documentos que comprovem seu direito à Assinatura Social. Pode
        enviar para o email:
      </h2>
      <h2>
        <a href="mailto:contato@direcaoconcursos.com.br" target="_blank" rel="noreferrer">
          <b>contato@direcaoconcursos.com.br</b>
        </a>
      </h2>
      <br />
      <h2>Fique sempre de olho aqui para acompanhar as novidades!</h2>
      <br />
      <h2>Bons estudos! </h2>
      <h2>Prof. Victor Dalton</h2>
      <h2 style={{ marginTop: '4rem', fontSize: '13px' }}>
        * Caso já tenha enviado, por favor, desconsidere essa mensagem.
      </h2>

      <OkButton id="ok" onClick={() => closeInformationModal()}>
        OK
      </OkButton>
    </Wrapper>
  )
}

export default InformationMessage
